<!-- ============================================================== -->
<!-- Start Main Content -->
<!-- ============================================================== -->
<div class="wrapper">
    <app-topbar></app-topbar>
    <app-sidebar-menu></app-sidebar-menu>

    <div class="content-page">
        <div class="container-fluid">
            <!-- <div class="page-title-head d-flex align-items-center">
                <div class="flex-grow-1">
                    <h4 class="page-main-title m-0">On Hover Menu</h4>
                </div>

                <div class="text-end">
                    <ol class="breadcrumb m-0 py-0">

                        <li *ngFor="let item of breadcrumbs; let last = last" class="breadcrumb-item"
                            [class.active]="last">

                            <a *ngIf="!last" [routerLink]="item.url">
                                {{item.label}}
                            </a>

                            <span *ngIf="last">
                                {{item.label}}
                            </span>

                        </li>

                    </ol>
                </div>
            </div> -->
           
            <div class="page-title-head d-flex align-items-center">
                <div class="flex-grow-1">
                    <h4 class="page-main-title m-0">{{ pageTitle$ | async }}</h4>
                </div>

                <div class="text-end">
                    <!-- <ol class="breadcrumb m-0 py-0">
                        <li class="breadcrumb-item"><a href="javascript: void(0);">Dhonu</a></li>
                        <li class="breadcrumb-item active">On Hover Menu</li>
                    </ol> -->
                    <ol class="breadcrumb m-0 py-0">
                        <li class="breadcrumb-item">
                            <a routerLink="/dashboard">Dashboard</a>
                        </li>

                        <li class="breadcrumb-item" *ngFor="let crumb of (breadcrumbs$ | async); let last = last"
                            [class.active]="last">

                            <a *ngIf="!last" [routerLink]="crumb.url">
                                {{ crumb.label }}
                            </a>

                            <span *ngIf="last">
                                {{ crumb.label }}
                            </span>
                        </li>
                    </ol>
                </div>
            </div>



            <!-- ************feature Layout Start***************** -->
            <router-outlet />

            <!-- ************feature Layout End***************** -->


            <!-- end row-->
        </div>
        <!-- container -->

        <!-- Footer Start -->
        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 text-center">
                        ©
                        <script>
                            document.write(new Date().getFullYear())
                        </script>
                        <span class="fw-semibold">Fastglobe</span> All Rights Reserved.
                    </div>
                </div>
            </div>
        </footer>
        <!-- end Footer -->

    </div>
</div>
<!-- ============================================================== -->
<!-- End of Main Content -->
<!-- ============================================================== -->